import React, { Component } from 'react';
import { Radio, DatePicker, Input, InputNumber, Button, Spin, message, Modal } from 'antd';
import { DepartmentDetail as UpdateDetail } from './UpdateDetail';
import RequirementTable from './RequirementTable';
import CompanyTable from './CompanyTable';
import DiseaseTable from './DiseaseTable';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import moment from 'moment';
import EuotetDepartmengt from './EuotetDepartmengt';

const confirm = Modal.confirm;
const { TextArea } = Input; 
const monthFormat = 'YYYY-MM';
const RadioGroup = Radio.Group;
const { MonthPicker } = DatePicker;

class Department extends Component {
    state = {
        params: {},
        isEdit: false,
        loading: false,
        companyList: [],
        outpatientsList: [],
        requirementList: [],
        List: [],
        oldReviewDepartmentId: '',
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = (newDepartmentId) => {
        const { hospitalDepartmentId } = this.props;
        let {oldReviewDepartmentId} = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryReviewDepartment,
            data: { hospitalDepartmentId: newDepartmentId ? newDepartmentId : hospitalDepartmentId},
            dataType: 'json',
            doneResult: res => {
                const { data = {}, log = {}, crcCount } = res;
                const { updateTime } = log || {};
                const { reviewDepartmentOutpatients = [], reviewDepartmentCompetitions = [], reviewDepartmentRequirements = [] } = data || {};
                const params = { ...(data || {}), crcCount };
                if(!newDepartmentId && data){ oldReviewDepartmentId = data.reviewDepartmentId }else{
                    params.reviewDepartmentId = oldReviewDepartmentId;
                }
                delete params.reviewDepartmentOutpatients;
                delete params.reviewDepartmentCompetitions;
                delete params.reviewDepartmentRequirements;
                this.setState({
                    params,
                    loading: false,
                    companyList: reviewDepartmentCompetitions,
                    outpatientsList: reviewDepartmentOutpatients,
                    requirementList: reviewDepartmentRequirements,
                    updateTime: updateTime ? updateTime.slice(0, 10) : '',
                    oldReviewDepartmentId,
                });
            }
        };
        $.sendRequest(options);
    }
    
    handleSave = () => {
        const { params } = this.state;
        if(params.closeCooperation === 'NOT_UNDERTAKE' && !params.cooperationRejectReason){
            message.error('请输入不承接原因！');
            return
        }
        const { clinicalTrialStartTime } = params;
        const { hospitalDepartmentId } = this.props;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.saveReviewDepartment,
            data: {
                ...params,
                hospitalDepartmentId,
                clinicalTrialStartTime: clinicalTrialStartTime ? clinicalTrialStartTime.slice(0, 7) : '',
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    isEdit: false,
                    loading: false,
                }, () => {
                    this.loadData();
                });
            }
        };
        $.sendRequest(options);
    }

    handleDateChange = (date, dateString, key) => {
        const { params } = this.state;
        params[key] = dateString;
        this.setState({ params });
    }

    handleInputChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        if (key === 'closeCooperation') {
            params.failureCooperateReason = '';
            if( e.target.value !== 'NOT_UNDERTAKE'){
                params.cooperationRejectReason = '';
            }
        } else if (key === 'recommendationIndex') {
            params.recommendationReason = '';
        }
        this.setState({ params });
    }

    handleSelectChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({
            params,
        });
    }

    getComment = (isEdit, key) => {
        const { params } = this.state;
        return (
            <div className="comment-value">
                {
                    isEdit ?
                        <Input
                            maxLength='240'
                            placeholder='请输入'
                            style={{ width: 240 }}
                            value={params[key]}
                            onChange={value => this.handleInputChange(value, key)}
                        />
                    :
                        params[key]
                }
            </div>
        )
    }

    handleEdit = (isEdit) => {
        this.setState({ isEdit }, () => {
            !isEdit && this.loadData();
        });
    }

    handleEuotet = () => {
        const { hospitalDepartmentId } = this.props;
        const options = {
            method: "POST",
            url: API_URL.hospital.queryReferReviewDepartment,
            data: { hospitalDepartmentId },
            dataType: "json",
            doneResult: (res) => {
                const { datas } = res
                if ( datas[0] ) {
                    this.setState({
                        List: datas,
                    },() => this.euotetDepartmengtlRef.show())
                }else{
                    Modal.warning({
                        content: '无可用科室',
                    });
                }
                
            },
            errorResult: () => {
                message.error('This is a message of error')
            },
        };
        $.sendRequest(options);
    
    }

    changeHospitalDepartmentId = (value) => {
        this.setState({
            hospitalDepartmentId: value
        })
    }

    showDetail = reviewDepartmentId => {
        this.detailRef.show(reviewDepartmentId);
    }

    render() {
        const { isAdd, hospitalDepartmentId } = this.props;
        const { isEdit, params, loading, companyList, updateTime, outpatientsList, requirementList, List } = this.state;
        const {
            reviewDepartmentId,
            departmentBedNum,
            monthlyHospitalizationNum,
            clinicalTrialStartTime,
            workEnvironment,
            workEnvironmentShow,
            closeCooperation,
            closeCooperationShow,
            failureCooperateReason,
            cooperationRejectReason,
            recommendationIndex,
            recommendationIndexShow,
            recommendationReason,
            crcCount,
            specialRequirements,
            specialRequirementsShow,
            comments,
        } = params;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Spin spinning={loading}>
                {
                    updateTime &&
                    <div style={{ textAlign: 'right' }}>
                        更新时间：{updateTime}
                        <i
                            className="icon iconfont"
                            onClick={() => this.showDetail(reviewDepartmentId)}
                            style={{ marginLeft: 4, fontSize: '16px', color: '#c4c1f1', cursor: 'pointer' }}
                        >&#xe601;</i>
                    </div>
                }
                <div className="modal-page" style={{ height: 500, marginTop: 10, overflowX: 'auto', background: '#f6f6f6' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="field-name">科室病床数</div>
                            <div className="field-value">
                                {
                                    isEdit ?
                                        <InputNumber
                                            placeholder='请输入'
                                            min={0}
                                            precision={0}
                                            style={{ width: 200 }}
                                            value={departmentBedNum}
                                            onChange={value => this.handleSelectChange(value, 'departmentBedNum')}
                                        />
                                    :
                                        departmentBedNum
                                }
                            </div>
                            <div className="comment-name">备注：</div>
                            {this.getComment(isEdit, 'departmentBedNumComments')}
                        </li>
                        <li className="modal-item">
                            <div className="field-name">科室月住院量</div>
                            <div className="field-value">
                                {
                                    isEdit ?
                                        <InputNumber
                                            placeholder='请输入'
                                            min={0}
                                            precision={0}
                                            style={{ width: 200 }}
                                            value={monthlyHospitalizationNum}
                                            onChange={value => this.handleSelectChange(value, 'monthlyHospitalizationNum')}
                                        />
                                    :
                                        monthlyHospitalizationNum
                                }
                            </div>
                            <div className="comment-name">备注：</div>
                            {this.getComment(isEdit, 'monthlyHospitalizationNumComments')}
                        </li>
                        <li className="modal-item">
                            <div className="field-name">某疾病的月门诊量、出诊医生数量</div>
                            <div className="field-value" style={{ width: '75%' }}>
                                <DiseaseTable
                                    isEdit={isEdit}
                                    loading={loading}
                                    dataSource={outpatientsList}
                                    reviewDepartmentId={reviewDepartmentId}
                                    hospitalDepartmentId={hospitalDepartmentId}
                                    onChange={value => this.handleSelectChange(value, 'reviewDepartmentId')}
                                />
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="field-name">科室首次承接临床试验时间</div>
                            <div className="field-value">
                                {
                                    isEdit ?
                                        <MonthPicker
                                            placeholder="请选择"
                                            style={{ width: 200 }}
                                            format={monthFormat}
                                            value={clinicalTrialStartTime ? moment(clinicalTrialStartTime) : null}
                                            onChange={(date, dateString) => this.handleDateChange(date, dateString, "clinicalTrialStartTime")}
                                        />
                                    :
                                        clinicalTrialStartTime ? clinicalTrialStartTime.slice(0, 7) : ''
                                }
                            </div>
                            <div className="comment-name">备注：</div>
                            {this.getComment(isEdit, 'clinicalTrialStartTimeComments')}
                        </li>
                        <li className="modal-item">
                            <div className="field-name">科室工作环境</div>
                            <div className="field-value">
                                {
                                    isEdit ?
                                        <RadioGroup value={workEnvironment} onChange={e => this.handleInputChange(e, 'workEnvironment')}>
                                            <Radio value="GOOD">好</Radio>
                                            <Radio value="Better">较好</Radio>
                                            <Radio value="Average">中</Radio>
                                            <Radio value="Poor">差</Radio>
                                        </RadioGroup>
                                    :
                                        workEnvironmentShow
                                }
                            </div>
                            <div className="comment-name">备注：</div>
                            {this.getComment(isEdit, 'workEnvironmentComments')}
                        </li>
                        <li className="modal-item">
                            <div className="field-name">津石合作紧密程度</div>
                            <div className="field-value">
                                {
                                    isEdit ?
                                        <RadioGroup value={closeCooperation} onChange={e => this.handleInputChange(e, 'closeCooperation')}>
                                            <Radio value="GOOD">好</Radio>
                                            <Radio value="Better">较好</Radio>
                                            <Radio value="Average">中</Radio>
                                            <Radio value="Poor">差</Radio>
                                            <Radio value="Temporarily_Unable_Cooperate">暂时无法合作</Radio>
                                            <Radio value="NOT_UNDERTAKE">不承接</Radio>
                                        </RadioGroup>
                                    :
                                        closeCooperationShow
                                }
                            </div>
                            <div className="comment-name">备注：</div>
                            {this.getComment(isEdit, 'closeCooperationComments')}
                        </li>
                        {
                            closeCooperation === 'Temporarily_Unable_Cooperate' &&
                            <li className="modal-item">
                                <div className="field-name">无法合作原因</div>
                                <div className="field-value">
                                    {
                                        isEdit ?
                                            <TextArea
                                                rows={4}
                                                placeholder="请输入"
                                                value={failureCooperateReason}
                                                onChange={e => this.handleInputChange(e, 'failureCooperateReason')}
                                                style={{ width: 300 }}
                                            />
                                        :
                                            failureCooperateReason
                                    }
                                </div>
                            </li>
                        }
                        {
                            closeCooperation === 'NOT_UNDERTAKE' &&
                            <li className="modal-item">
                                <div className="field-name">{asterisk}不承接原因</div>
                                <div className="field-value">
                                    {
                                        isEdit ?
                                            <TextArea
                                                rows={4}
                                                placeholder="请输入"
                                                value={cooperationRejectReason}
                                                onChange={e => this.handleInputChange(e, 'cooperationRejectReason')}
                                                style={{ width: 300 }}
                                            />
                                        :
                                            cooperationRejectReason
                                    }
                                </div>
                            </li>
                        }
                        <li className="modal-item">
                            <div className="field-name">科室综合推荐指数</div>
                            <div className="field-value">
                                {
                                    isEdit ?
                                        <RadioGroup value={recommendationIndex} onChange={e => this.handleInputChange(e, 'recommendationIndex')}>
                                            <Radio value="Highly_Recommended">极力推荐</Radio>
                                            <Radio value="Recommended">推荐</Radio>
                                            <Radio value="Generally_Recommended">一般</Radio>
                                            <Radio value="Not_Recommended">不推荐</Radio>
                                        </RadioGroup>
                                    :
                                        recommendationIndexShow
                                }
                            </div>
                            <div className="comment-name">备注：</div>
                            {this.getComment(isEdit, 'recommendationIndexComments')}
                        </li>
                        {
                            (recommendationIndex === 'Highly_Recommended' || recommendationIndex === 'Recommended') &&
                            <li className="modal-item">
                                <div className="field-name">科室推荐理由</div>
                                <div className="field-value">
                                    {
                                        isEdit ?
                                            <TextArea
                                                rows={4}
                                                placeholder="请输入"
                                                value={recommendationReason}
                                                onChange={e => this.handleInputChange(e, 'recommendationReason')}
                                                style={{ width: 300 }}
                                            />
                                        :
                                            recommendationReason
                                    }
                                </div>
                            </li>
                        }
                        <li className="modal-item">
                            <div className="field-name">该科室竞争公司的CRC人数</div>
                            <div className="field-value" style={{ width: '75%' }}>
                                <CompanyTable
                                    isEdit={isEdit}
                                    loading={loading}
                                    dataSource={companyList}
                                    reviewDepartmentId={reviewDepartmentId}
                                    hospitalDepartmentId={hospitalDepartmentId}
                                    onChange={value => this.handleSelectChange(value, 'reviewDepartmentId')}
                                />
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="field-name">津石同期CRC人数</div>
                            <div className="field-value">
                                {crcCount}
                            </div>
                            <div className="comment-name">备注：</div>
                            {this.getComment(isEdit, 'crcCountComments')}
                        </li>
                        <li className="modal-item">
                            <div className="field-name">该科室对SMO有无特殊要求</div>
                            <div className="field-value">
                                {
                                    isEdit ?
                                        <RadioGroup value={specialRequirements} onChange={e => this.handleInputChange(e, 'specialRequirements')}>
                                            <Radio value="YES">有</Radio>
                                            <Radio value="NO">无</Radio>
                                        </RadioGroup>
                                    :
                                        specialRequirementsShow
                                }
                            </div>
                            <div className="comment-name">备注：</div>
                            {this.getComment(isEdit, 'specialRequirementsComments')}
                        </li>
                        {
                            specialRequirements === 'YES' &&
                            <li className="modal-item">
                                <div className="field-name">&nbsp;</div>
                                <div className="field-value" style={{ width: '75%' }}>
                                    <RequirementTable
                                        isEdit={isEdit}
                                        loading={loading}
                                        dataSource={requirementList}
                                        reviewDepartmentId={reviewDepartmentId}
                                        hospitalDepartmentId={hospitalDepartmentId}
                                        onChange={value => this.handleSelectChange(value, 'reviewDepartmentId')}
                                    />
                                </div>
                            </li>
                        }
                        <li className="modal-item">
                            <div className="field-name">科室备注</div>
                            <div className="field-value">
                                {
                                    isEdit ?
                                        <TextArea
                                            rows={4}
                                            placeholder="请输入"
                                            value={comments}
                                            onChange={e => this.handleInputChange(e, 'comments')}
                                            style={{ width: 300 }}
                                        />
                                    :
                                        comments
                                }
                            </div>
                        </li>
                    </ul>
                </div>
                {
                    isAdd &&
                    <div style={{ marginTop: 8, textAlign: 'center' }}>
                        {
                            isEdit ?
                                <span>
                                    <Button type="primary" style={{ marginRight: 16 }} onClick={this.handleSave}>保存</Button>
                                    <Button type="primary" onClick={() => this.handleEdit(false)}>取消</Button>
                                </span>
                            :
                            <span>
                                <Button type="primary" className="yellow" style={{ marginRight: 16 }} onClick={()=>this.handleEuotet()}>引用</Button>
                                <Button type="primary" onClick={() => this.handleEdit(true)}>编辑</Button>
                            </span>
                        }
                    </div>
                }
                <UpdateDetail ref={el => this.detailRef = el} loadData={this.loadData} />
                <EuotetDepartmengt
                    List={List} 
                    loadData={this.loadData}
                    hospitalDepartmentId={this.state.hospitalDepartmentId}
                    changeHospitalDepartmentId={this.changeHospitalDepartmentId}
                    ref={el => this.euotetDepartmengtlRef = el } 
                />
            </Spin>
        );
    }
}

export default Department;


// WEBPACK FOOTER //
// ./src/components/hospital/commentInfo/Department.js